const backendURL = process.env.REACT_APP_HOSTNAME 
  ? `${process.env.REACT_APP_HOSTNAME}/api` 
  : undefined;

export default backendURL;
